import React from 'react';
import { observer, inject } from 'mobx-react';
import { Label, mergeStyleSets, FontSizes, FontWeights } from '@fluentui/react';

import RevokeAccessTokenButton from 'src/components/debug/RevokeAccessTokenButton';

const classNames = mergeStyleSets({
  root: {
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  block: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    marginBottom: 26,
    selectors: { '& > *': { marginBottom: 16 } },
  },
  title: {
    fontSize: FontSizes.large,
    fontWeight: FontWeights.semilight,
    marginBottom: 16,
  },
});

const Debug = ({ userStore }) => (
  <div className={classNames.root}>
    <div className={classNames.block}>
      <Label className={classNames.title}>Salesforce</Label>
      <RevokeAccessTokenButton token={userStore.token} />
    </div>
  </div>
);

export default inject('userStore')(observer(Debug));
